import type { TOC } from '@ember/component/template-only';
import { PhCheck } from 'ember-phosphor-icons';

interface ConfirmationCheckIconSignature {
  Element: HTMLDivElement;
}

/**
 * Confirmation check animation runs once on mount. Purple-500 and white stay fixed across themes to
 * match the confirmation specification.
 */
const ConfirmationCheckIcon: TOC<ConfirmationCheckIconSignature> = <template>
  <div
    class="tio-confirmation-check"
    data-test-confirmation-check-icon
    aria-hidden="true"
    ...attributes
  >
    <span class="tio-confirmation-check-glow"></span>
    <span class="tio-confirmation-check-circle">
      <PhCheck @size={{16}} @weight="bold" class="tio-confirmation-check-icon" />
    </span>
  </div>
</template>;

export default ConfirmationCheckIcon;
